module.exports = __webpack_public_path__ + "img/Mocilac-Dubravko.356d4931.jpg";